export default class User {
  static user = {
    id: '',
    name: '',
    currentLesson: ''
  }

  /**
  * @name id
  * @function
  * @param {}
  * @description: getter for user
  */
  static getUser() {
    return User.user;
  }

  /**
  * @name setUser
  * @function
  * @param {value}
  * @description: setter for user
  */
  static setUser(value) {
    User.user = value;
  }
}


// WEBPACK FOOTER //
// ./src/classes/user.js